import { render } from "./MenuBodyMainV2.vue?vue&type=template&id=5893e00e&scoped=true"
import script from "./MenuBodyMainV2.vue?vue&type=script&lang=js"
export * from "./MenuBodyMainV2.vue?vue&type=script&lang=js"

import "./MenuBodyMainV2.vue?vue&type=style&index=0&id=5893e00e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5893e00e"]])

export default __exports__